import * as fromDatatype from "../datatype-library/index";

export interface bl_wms_grn_container_link_RowInterface {
    guid : fromDatatype.GuidDataFieldInterface;
    wms_grn_hdr_guid : fromDatatype.GuidDataFieldInterface;
    wms_grn_line_guid : fromDatatype.GuidDataFieldInterface;
    wms_item_guid : fromDatatype.GuidDataFieldInterface;
    wms_item_code : fromDatatype.VarcharDatatypeInterface;
    fi_item_guid : fromDatatype.GuidDataFieldInterface;
    inv_item_guid : fromDatatype.GuidDataFieldInterface;
    container_hdr_guid : fromDatatype.GuidDataFieldInterface;
    container_line_guid : fromDatatype.GuidDataFieldInterface;
    container_node_guid : fromDatatype.GuidDataFieldInterface;
    container_label_guid : fromDatatype.GuidDataFieldInterface;
    uom : fromDatatype.VarcharDatatypeInterface;
    base_qty : fromDatatype.NumericDatatypeInterface;
    uom_qty : fromDatatype.NumericDatatypeInterface;
    property_json : fromDatatype.JsonDatatypeInterface;
    namespace : fromDatatype.VarcharDatatypeInterface;
    applet_guid  : fromDatatype.GuidDataFieldInterface;
    module_guid  : fromDatatype.GuidDataFieldInterface;
    acl_config : fromDatatype.JsonDatatypeInterface;
    acl_policy : fromDatatype.JsonDatatypeInterface;
    created_date : fromDatatype.TimestampTzDatatypeInterface;
    updated_date : fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid  : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid  : fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision  : fromDatatype.GuidDataFieldInterface;
    vrsn : fromDatatype.VarcharDatatypeInterface;
    split_qty: fromDatatype.NumericDatatypeInterface;
}

export class bl_wms_grn_container_link_RowClass implements bl_wms_grn_container_link_RowInterface {
    guid : fromDatatype.GuidDataFieldInterface;
    wms_grn_hdr_guid : fromDatatype.GuidDataFieldInterface;
    wms_grn_line_guid : fromDatatype.GuidDataFieldInterface;
    wms_item_guid : fromDatatype.GuidDataFieldInterface;
    wms_item_code : fromDatatype.VarcharDatatypeInterface;
    fi_item_guid : fromDatatype.GuidDataFieldInterface;
    inv_item_guid : fromDatatype.GuidDataFieldInterface;
    container_hdr_guid : fromDatatype.GuidDataFieldInterface;
    container_line_guid : fromDatatype.GuidDataFieldInterface;
    container_node_guid : fromDatatype.GuidDataFieldInterface;
    container_label_guid : fromDatatype.GuidDataFieldInterface;
    uom : fromDatatype.VarcharDatatypeInterface;
    base_qty : fromDatatype.NumericDatatypeInterface;
    uom_qty : fromDatatype.NumericDatatypeInterface;
    property_json : fromDatatype.JsonDatatypeInterface;
    namespace : fromDatatype.VarcharDatatypeInterface;
    applet_guid  : fromDatatype.GuidDataFieldInterface;
    module_guid  : fromDatatype.GuidDataFieldInterface;
    acl_config : fromDatatype.JsonDatatypeInterface;
    acl_policy : fromDatatype.JsonDatatypeInterface;
    created_date : fromDatatype.TimestampTzDatatypeInterface;
    updated_date : fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid  : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid  : fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision  : fromDatatype.GuidDataFieldInterface;
    vrsn : fromDatatype.VarcharDatatypeInterface;
    split_qty: fromDatatype.NumericDatatypeInterface;
}